import { render, staticRenderFns } from "./UserAccountPage.vue?vue&type=template&id=0c083067&scoped=true"
import script from "./UserAccountPage.vue?vue&type=script&lang=js"
export * from "./UserAccountPage.vue?vue&type=script&lang=js"
import style0 from "./UserAccountPage.vue?vue&type=style&index=0&id=0c083067&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c083067",
  null
  
)

export default component.exports